import React from 'react'
import { useParamsInt } from '../../../../shared/hooks/location'
import { useHistory } from 'react-router-dom'
import { useApiFormAnalyticParent, useApiListAnalyticParentType } from '../../../../api-new/state/analytics'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { IconAdd } from '../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../shared/card/card-full-height-scroll-y'
import { Card } from '../../../../shared/card/card'
import { Form, FormSubmitCancel, FormText, FormTextArea } from '../../../../shared/form/form'
import { FormSelectObj } from '../../../../shared/form/form-select-obj'

export const AnalyticParentEdit = () => {
  const { id } = useParamsInt()

  const history = useHistory()

  const apiFormAnalyticParent = useApiFormAnalyticParent()
  const apiListAnalyticParentType = useApiListAnalyticParentType()

  const handleMatch = async () => {
    apiFormAnalyticParent.get(id)
    apiListAnalyticParentType.get()
  }

  const handleSubmit = async data => {
    await apiFormAnalyticParent.put(data.id, data)
    history.goBack()
  }

  const handleClose = () => history.goBack()

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconAdd} text="Edit" onMatch={handleMatch}>
        <CardFullHeightScrollY title="Edit Analytic Parent">
          <Card>
            <Form state={apiFormAnalyticParent.form} onSubmit={handleSubmit} onRefresh={handleMatch}>
              <FormSelectObj
                label="parent type"
                state={apiListAnalyticParentType}
                name="analyticParentTypeID"
                itemName="name"
                itemValue="id"
                valueAsNumber
                required
              />
              <FormText label="name" name="name" autoFocus />
              <FormTextArea label="description" name="description" />
              <FormText label="resource" name="resource" />
              <FormSubmitCancel onCancel={handleClose} />
            </Form>
          </Card>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
